// Wiki filter ([data-wiki-filter], the /hilfe and /faq listings): search box, topic select and kind pills narrow the
// list in the browser. Each [data-filter-item] carries data-topics (category aliases), data-kind and data-text
// (lower-case text to search); every word of the search must occur. The search term arrives as ?q= from the start
// page's search box, and search, topic and kind are kept in the URL (?q, ?thema, ?art) so a filtered list can be
// shared. Groups ([data-filter-group], the glossary's letters) without a visible item are hidden too. Without script
// the whole list shows.
const norm = (s) => s.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss')

export function initWikiFilters() {
	document.querySelectorAll('[data-wiki-filter]').forEach(setupFilter)
}

function setupFilter(root) {
	const search = root.querySelector('[data-filter-search]')
	const topic = root.querySelector('[data-filter-topic]')
	const kinds = [...root.querySelectorAll('[data-filter-kind]')]
	const items = [...root.querySelectorAll('[data-filter-item]')].map((el) => ({
		el,
		topics: (el.dataset.topics || '').split(' '),
		kind: el.dataset.kind || '',
		text: norm(el.dataset.text || el.textContent),
	}))
	const groups = [...root.querySelectorAll('[data-filter-group]')]
	const count = root.querySelector('[data-filter-count]')
	const empty = root.querySelector('[data-filter-empty]')
	let kind = ''

	const params = new URLSearchParams(location.search)
	if (search && params.get('q')) search.value = params.get('q')
	if (topic && params.get('thema')) topic.value = params.get('thema')
	if (params.get('art') && kinds.some((b) => b.dataset.filterKind === params.get('art'))) kind = params.get('art')

	const apply = () => {
		const words = norm(search?.value || '').split(/\s+/).filter(Boolean)
		const t = topic?.value || ''
		let shown = 0
		for (const item of items) {
			const match = (!t || item.topics.includes(t)) && (!kind || item.kind === kind) && words.every((w) => item.text.includes(w))
			item.el.hidden = !match
			if (match) shown += 1
		}
		groups.forEach((g) => { g.hidden = !g.querySelector('[data-filter-item]:not([hidden])') })
		kinds.forEach((b) => {
			const on = b.dataset.filterKind === kind
			b.classList.toggle('is-active', on)
			b.setAttribute('aria-pressed', String(on))
		})
		if (count) count.textContent = `${shown} ${shown === 1 ? count.dataset.labelOne : count.dataset.labelMany}`
		if (empty) empty.hidden = shown > 0
		const url = new URL(location.href)
		for (const [key, value] of [['q', search?.value.trim()], ['thema', t], ['art', kind]]) {
			if (value) url.searchParams.set(key, value)
			else url.searchParams.delete(key)
		}
		history.replaceState(null, '', url)
	}

	search?.addEventListener('input', apply)
	topic?.addEventListener('change', apply)
	kinds.forEach((b) => b.addEventListener('click', () => {
		kind = b.dataset.filterKind
		apply()
	}))
	apply()
}
